

function Footer() {

  return (
    <footer>
      <div className="footer">
        <a href='https://github.com/Jherrera1234/'> <img className="github-image" src="https://avatars.githubusercontent.com/u/9919?s=280&v=4" alt="GitHub-img" /></a>
        <br />
        <a href='https://www.linkedin.com/in/jorge-herrera-bba82a199/' > <img className='linkedin-image' src="https://www.edigitalagency.com.au/wp-content/uploads/new-linkedin-logo-white-black-png.png" alt="Linkedin-Img" /></a>
      </div>
    </footer>
  )


}

export default Footer